module.exports = __webpack_public_path__ + "static/media/Location.7687865e.png";